// A made-up account for the sign-up form of a development machine, so the welcome can be walked again
// and again without inventing an email each time. The button that uses it is only drawn when the server
// skips the verification email (sparring.auth.skip-email-verification), which is never in production.
//
// Pure: the randomness comes in as a function, so the tests can pin it.

import { isValidPassword } from "./passwordRules.ts";

export const TEST_ACCOUNT_DOMAIN = "sparringchess.local";

const FIRST_NAMES = ["Ana", "Bruno", "Carla", "Diego", "Elena", "Fabio", "Gala", "Hugo", "Irene", "Jorge",
    "Lucia", "Mateo", "Nuria", "Oscar", "Paula", "Raul", "Sara", "Tomas", "Vera", "Xavi"];
const PLAYERS = ["Tal", "Capablanca", "Morphy", "Polgar", "Carlsen", "Fischer", "Botvinnik", "Petrosian",
    "Spassky", "Karpov", "Kasparov", "Anand", "Hou", "Nakamura", "Ding", "Aronian"];
const LOWER = "abcdefghjkmnpqrstuvwxyz";
const UPPER = "ABCDEFGHJKMNPQRSTUVWXYZ";
const DIGITS = "23456789";

export interface TestAccount {
    email: string;
    displayName: string;
    password: string;
}

/** `random` answers in [0, 1), like Math.random. */
export function randomTestAccount(random: () => number = Math.random): TestAccount {
    const pick = <T>(list: readonly T[] | string): T => list[Math.floor(random() * list.length)] as T;
    const first = pick<string>(FIRST_NAMES);
    const player = pick<string>(PLAYERS);
    const number = 100 + Math.floor(random() * 900);
    const tag = `${first}${player}${number}`.toLowerCase();

    // One of each kind first, so it always passes the rule, then four more of anything
    let password = pick<string>(UPPER) + pick<string>(LOWER) + pick<string>(LOWER) + pick<string>(DIGITS);
    const all = LOWER + UPPER + DIGITS;
    for (let i = 0; i < 6; i++) password += pick<string>(all);
    if (!isValidPassword(password)) throw new Error(`A test password broke the rule: ${password}`);

    return {
        email: `test+${tag}@${TEST_ACCOUNT_DOMAIN}`,
        displayName: `${first} ${player}`,
        password,
    };
}
